/**
 * Notification preferences — the self-service read and write.
 *
 * GET /v1/notifications/preferences?user_id=     → every type, merged with defaults
 * PUT /v1/notifications/preferences/:type?user_id= → the one preference written
 */

import { z } from 'zod'
import { NotificationPreferenceItemSchema } from '../../schemas/entities/notification-preference'

export const GetNotificationPreferencesResponseSchema = z.object({
  data: z.array(NotificationPreferenceItemSchema),
  message: z.string()
})
export type GetNotificationPreferencesResponse = z.infer<typeof GetNotificationPreferencesResponseSchema>

export const UpdateNotificationPreferenceResponseSchema = z.object({
  data: NotificationPreferenceItemSchema,
  message: z.string()
})
export type UpdateNotificationPreferenceResponse = z.infer<typeof UpdateNotificationPreferenceResponseSchema>
